import {Component, OnInit, Input } from '@angular/core';
import { InputGridFunctionsModel } from '../input-grid-functions.model';

@Component({
    selector: 'abw-input-grid-functions-result',
    templateUrl: './input-grid-functions-result.component.html',
    styleUrls: ['./input-grid-functions-result.component.scss']
})
export class InputGridFunctionsResultComponent implements OnInit {
	@Input() model: InputGridFunctionsModel;
    @Input() value: any;

    constructor() { }

    ngOnInit() {  }
}